import React from 'react';

import { useAppStore } from '@/shared/contexts/app-wrapper/providers/app-provider';

import CreateFormButton from '../common/create-form-button';
import FormFilters from './form-filters';

function FormDashboardHeader() {
	const isApplicantMode = useAppStore((state) => state.isApplicantMode);

	return (
		<div className="mb-3 mt-9 px-4 md:mb-3 md:px-6">
			<div className="mb-10 flex items-center justify-between gap-4">
				<h1 className="text-2xl font-semibold">Forms</h1>

				<CreateFormButton />
			</div>

			{isApplicantMode ? null : <FormFilters />}
		</div>
	);
}

export default FormDashboardHeader;
